export interface Contact {
	type: ContactType;
	label: string;
	value: string;
	icon: string;
	customIcon: string;
	link?: string;
}

export enum ContactType {
	Phone,
	Email,
	Viber,
	WhatsApp,
}
